export type SupportedLanguage = 'en' | 'fr';

export const getCurrentLanguage = (): SupportedLanguage => {
  if (typeof window !== 'undefined') {
    const urlLanguage = new URLSearchParams(window.location.search).get('language');
    if (urlLanguage === 'fr' || urlLanguage === 'en') {
      return urlLanguage;
    }

    const storedLanguage = window.localStorage.getItem('language');
    if (storedLanguage === 'fr' || storedLanguage === 'en') {
      return storedLanguage;
    }
  }

  if (typeof document !== 'undefined') {
    const documentLanguage = document.documentElement.lang.toLowerCase();
    if (documentLanguage.startsWith('fr')) {
      return 'fr';
    }
    if (documentLanguage.startsWith('en')) {
      return 'en';
    }
  }

  if (typeof navigator !== 'undefined') {
    return navigator.language.toLowerCase().startsWith('fr') ? 'fr' : 'en';
  }

  return 'en';
};
